"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DhtCallContext = void 0;
const proto_rpc_1 = require("@streamr/proto-rpc");
class DhtCallContext extends proto_rpc_1.ProtoCallContext {
    // used by client
    targetDescriptor;
    sourceDescriptor;
    clientId;
    connect;
    sendIfStopped;
    doNotBufferWhileConnecting;
    //used in incoming calls
    incomingSourceDescriptor;
}
exports.DhtCallContext = DhtCallContext;
//# sourceMappingURL=DhtCallContext.js.map